
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { commonModule, clientsModule, installationsModule, appointmentsModule, tasksModule, statsModule, jobsModule, dashboardModule, filterModule } from '@/store/modules/store-accessor'
import LoadingIndicator from '@/components/TheLoadingIndicator.vue'
import ClientsSideviewGeneralTab from '@/components/sideviews/clients/ClientsSideviewGeneralTab.vue'
import ClientsSideviewInstallationsTab from '@/components/sideviews/clients/ClientsSideviewInstallationsTab.vue'
import ClientsSideviewPaymentsTab from '@/components/sideviews/clients/ClientsSideviewPaymentsTab.vue'
import ClientsSideviewCreditTab from '@/components/sideviews/clients/ClientsSideviewCreditTab.vue'
import { TimeUtil } from '@/helpers/TimeUtil'
import TheMiniLoader from '@/components/TheMiniLoader.vue'
import { formatAmount } from "@/helpers/data";

@Component({
  components: {
    LoadingIndicator,
    ClientsSideviewGeneralTab,
    ClientsSideviewInstallationsTab,
    ClientsSideviewPaymentsTab,
    ClientsSideviewCreditTab,
    TheMiniLoader,
  }
})
export default class ClientsSideview extends Vue {
  @Prop()
  loading!: boolean;

  @Prop()
  payload!: any;

  tab = 0;

  isEditing!: boolean;

  async mounted() {
    installationsModule.getInstallationsByIdAction(this.payload['clientId']);
    commonModule.getContactTypeCombo();
    await this.refreshCredit();
  }

  async hideSideview () {
    commonModule.hideSideview();
  }

  get currClientId () {
    return this.payload['clientId'];
  }

  @Watch('currClientId')
  async onClientChanged() {
    await this.refreshCredit()
  }

  get currClient () {
    return clientsModule.currentClient;
  }

  get isLoading() {
    return clientsModule.isLoadingSideView;
  }

  get availableCredit() {
    const fromClient = this.currClient.info?.available_credit
    const value = fromClient ?? this.credit.available_credit ?? 0
    return Number(value)
  }

  get credit() {
    return clientsModule.currentCredit;
  }

  async refreshCredit() {
    await clientsModule.loadCurrentClientCredit(this.currClientId);
  }

  addCredit() {
    commonModule.showModal({name: 'record-prepayment-modal', payload: {clientId: this.currClientId, availableCredit: this.availableCredit}});
  }

  refundCredit() {
    commonModule.showModal({name: 'refund-credit-modal', payload: {clientId: this.currClientId, availableCredit: this.availableCredit}});
  }

  bulkPay() {
    commonModule.showModal({
      name: 'quick-add-payments-modal',
      payload: {
        scope: 'client',
        clientId: this.currClientId,
        entity: this.currClient.info,
      },
    });
  }

  clientIconSrc() {
    if (this.currClient.info.is_business) {
      return require('@/assets/img/company_icon.png');
    } else {
      return require('@/assets/img/client_icon.png');
    }
  }

  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

  updated() {
    this.isEditing = false;
  }

  async refreshData () {
    clientsModule.setIsLoadingSideView(true);
    await clientsModule.getClientsInfo(this.currClientId)
    await this.refreshCredit()
  }


  async editClient() {
    await clientsModule.getClientsInfo(this.currClientId)
    commonModule.showModal({ name: 'edit-client-modal', payload: { client: this.currClient.info, contacts: this.currClient.contacts, view: "clientsSideview" }})
  }

  deleteClient() {
    commonModule.showModal({ name: 'delete-client-modal', payload: { client: this.currClient.info }} )
  }

  formatBalance(balance: number) {
    return formatAmount(balance);
  }

  close () {
    clientsModule.unsetCurrentClient();

    switch(this.$route.name) {
      case 'Dashboard':
        dashboardModule.getDashboardAppointmentsAction(dashboardModule.filters);
        dashboardModule.getDashboardAppointmentsBarsAction(dashboardModule.filters);
        filterModule.getDashboardTasksFilters();
        dashboardModule.getDashboardPendingTasks(dashboardModule.taskFilters);
        break;
        case 'Installations':
        installationsModule.getInstallationsAction(installationsModule.filters);
        break;
        case 'Jobs':
        jobsModule.getJobs(jobsModule.filters);
        break;
        case 'Map':
        installationsModule.getInstallationsAction(installationsModule.filters);
        break;
        case 'Calendar':
        appointmentsModule.getCalendarAppointmentsAction(appointmentsModule.filters);
        break;
        case 'Clients':
          clientsModule.getClientsAction(clientsModule.filters);
          break;
    }

    this.hideSideview()
  }

};
